import React from 'react';
import { withRouter } from 'react-router-dom';
import Modal from 'react-modal';
import { compose } from 'redux';
import Loader from '4all-ui/components/Loader';
import SelectList from '../../SelectList';
import { AlertErrorIcon, CheckedIcon, CubeIcon, SendIcon } from '../../Icons';
import { customModalStyles, NEW_MENU } from '../../../helpers/constants';
import * as styles from '../style';
import withProducts from '../../../containers/Products';
import { getParentSelector } from '../../../helpers/modal';
import { withMenu } from '../../../containers/Menus';
import Storage from '../../../helpers/storage';

class ExportToMenuModal extends React.Component {
  state = {
    menu: { ...NEW_MENU },
    menuList: [],
    successExport: false,
    isDropDownOpen: false,
  };

  wrapperRef = null;

  async componentDidMount() {
    const { menus, getMenus } = this.props;
    let menuList = menus;

    if (menus.length === 0) {
      menuList = (await getMenus()) || [];
    }
    this.setState({
      menuList,
      menu: menuList[0],
    });
  }

  close = (finished = false) => {
    const { close, finishEditMenu } = this.props;

    this.setState({ successExport: false }, () => {
      close();
    });

    if (finished) {
      finishEditMenu();
    }
  };

  exportToMenu = async () => {
    const { menu } = this.state;
    const { modalProduct, editMenu } = this.props;
    const menuItems = [];
    const duplicatedProducts = [];

    let data = {
      delivery: menu.delivery,
      id: menu.id,
      inStore: menu.inStore,
      marketplaces: menu.marketplaces,
      merchantId: Storage.getLocalStorageMerchant().idUnity,
      name: menu.name,
      published: menu.published,
      shortDelivery: menu.shortDelivery,
      takeaway: menu.takeaway,
      voucher: menu.voucher,
    };

    menu.categories.forEach(cat => {
      cat.products.forEach(prod => {
        const productSelected = modalProduct.data.menuItems.find(p => p.productId === prod.id);
        if (productSelected) {
          duplicatedProducts.push({ id: prod.id, name: prod.name });
        }
        menuItems.push({
          productId: prod.id,
          price: productSelected ? productSelected.price : prod.price,
        });
      });
    });

    const concate = menuItems.concat(
      modalProduct.data.menuItems.filter(
        p => !duplicatedProducts.find(item => item.id === p.productId)
      )
    );

    data = {
      ...data,
      menuItems: concate.filter(
        (e, i) => concate.findIndex(a => a.productId === e.productId) === i
      ),
    };

    await editMenu(data);
    this.setState({ successExport: true });
  };

  toggleSelect = isOpen => {
    this.setState({ isDropDownOpen: isOpen });
  };

  getContent = () => {
    const { menuError, isLoadingMenus, count } = this.props;
    const { successExport, menuList, menu, isDropDownOpen } = this.state;

    if (isLoadingMenus) {
      return (
        <styles.ContentLoader>
          <Loader size="100px" width="8px" />
        </styles.ContentLoader>
      );
    }

    if (menuError.message) {
      return (
        <React.Fragment>
          <AlertErrorIcon />
          <styles.Title>{menuError.message}</styles.Title>
        </React.Fragment>
      );
    }

    if (successExport) {
      return (
        <React.Fragment>
          <CheckedIcon />
          <styles.Title>Seleção enviada para o cardápio</styles.Title>
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <SendIcon size="90px" />
        <styles.Title>Enviar seleção para cardápio</styles.Title>
        <styles.SendCountProducts>
          <CubeIcon />
          <styles.Text>
            {count}
            &nbsp;produto
            {count === 1 ? '' : 's'}
          </styles.Text>
        </styles.SendCountProducts>
        <styles.DivSelectList
          ref={node => {
            this.wrapperRef = node;
          }}
        >
          <SelectList
            list={menuList}
            onSelect={this.onSelect}
            isDroppedDown={isDropDownOpen}
            wrapperRef={this.wrapperRef}
            toggleSelect={this.toggleSelect}
            selected={menu}
            listStyle={menuList.length >= 5 ? { height: '185px' } : null}
          />
        </styles.DivSelectList>
      </React.Fragment>
    );
  };

  onSelect = data => {
    this.setState(state => ({
      menu: data || state.menu,
      isDropDownOpen: false,
    }));
  };

  render() {
    const { show, menuError, isLoadingMenus } = this.props;
    const { successExport, menuList } = this.state;
    const existsMenu = menuList.length > 0;

    return (
      <Modal
        ariaHideApp={false}
        isOpen={show}
        style={{
          ...customModalStyles,
          content: {
            ...customModalStyles.content,
            height: !successExport ? '460px' : '360px',
            width: 'auto',
            overflow: 'initial',
          },
        }}
        onRequestClose={this.close}
        parentSelector={getParentSelector}
      >
        <styles.Container>
          <styles.Content>{this.getContent()}</styles.Content>

          <styles.Footer center={successExport || menuError.message}>
            {successExport || menuError.message ? (
              <styles.OKButton onClick={() => this.close(true)} disabled={isLoadingMenus}>
                OK
              </styles.OKButton>
            ) : (
              <React.Fragment>
                <styles.CancelButton onClick={this.close} disabled={isLoadingMenus}>
                  Cancelar
                </styles.CancelButton>
                <styles.SendButton
                  onClick={this.exportToMenu}
                  disabled={isLoadingMenus || !existsMenu}
                >
                  Enviar
                </styles.SendButton>
              </React.Fragment>
            )}
          </styles.Footer>
        </styles.Container>
      </Modal>
    );
  }
}

export default compose(
  withRouter,
  withProducts,
  withMenu
)(ExportToMenuModal);



// WEBPACK FOOTER //
// ./src/components/GenericModal/ExportToMenuModal/index.js